import { StorageId } from '../types/StorageId';

export const getEmailOverrideParams = () => {
  const email = localStorage.getItem(StorageId.EmailOverride);
  return email ? `?emailOverride=${encodeURIComponent(email)}` : '';
};
